module.exports = __webpack_public_path__ + "img/full6-min.899affe1.png";